import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export type AutosaveState = "idle" | "saving" | "saved" | "error" | "offline";

export default function AutosaveIndicator({ state, savedAt }: { state: AutosaveState; savedAt?: number }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 5000); return () => clearInterval(t); }, []);
  const ago = savedAt ? Math.max(0, Math.floor((now - savedAt) / 1000)) : null;
  const label = state === "saving" ? "Saving…"
    : state === "saved" ? (ago == null ? "Saved" : ago < 5 ? "Saved just now" : `Saved ${ago}s ago`)
    // Batch 51 §3 — the recorder caps retries at 3 for network errors
    // and stops immediately on validation errors (autosaveBlockingMessage).
    // The old "retrying" copy implied a loop still running; it wasn't.
    // The "Retry Now" button rendered next to this indicator is the
    // actual manual retry affordance.
    : state === "error" ? "Save failed"
    : state === "offline" ? "Offline draft stored locally"
    : "—";
  const icon = state === "saving" ? <CircularProgress size={12} />
    : state === "saved" ? <CloudDoneIcon fontSize="inherit" />
    : state === "error" ? <ErrorOutlineIcon fontSize="inherit" color="error" />
    : state === "offline" ? <CloudOffIcon fontSize="inherit" />
    : null;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, color: state === "error" ? "error.main" : "text.secondary" }}>
      {icon}
      <Typography variant="caption">{label}</Typography>
    </Box>
  );
}
